import { useEffect } from 'react';

import { DeeplinkKeys } from '@/consts/deepLinks';
import { getAppStore, setAppStore } from '@/store';
import { extractUrlParams } from '@/utils/ui/extractUrlParams';
import { normalizeCategorySlug } from '@/utils/ui/normalizeCategorySlug';

const useCategoryDeeplink = () => {
  useEffect(() => {
    // Skip if task_id is present - notification handler will handle navigation
    const {
      [DeeplinkKeys.taskId]: taskId,
      [DeeplinkKeys.category]: genaicategory,
    } = extractUrlParams([DeeplinkKeys.category, DeeplinkKeys.taskId]);

    if (taskId || !genaicategory) return;

    const categorySlug = normalizeCategorySlug(genaicategory);
    if (!categorySlug) return;

    const { activeTabSlug } = getAppStore();
    setAppStore({
      ...(activeTabSlug !== categorySlug && { activeTabSlug: categorySlug }),
      screen: 'library',
      shouldScrollToActiveTab: true,
    });
  }, []);
};

export { useCategoryDeeplink };
